import { useState } from "react";
import { UploadWithAssetsDto } from "generated";
import Button from "@ingka/button";
import { useRemoveUploadMutation } from "@/hooks/uploads";
import { useToast } from "@/hooks/toast";
import Modal, { ModalFooter, Prompt } from "@ingka/modal";
import { MODAL_PROPS } from "./constants";

type Props = {
  upload: UploadWithAssetsDto;
  buttonText: string;
  navigate: () => void;
};

const DeleteUpload = ({ upload, buttonText, navigate = () => {} }: Props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const removeUploadMutation = useRemoveUploadMutation();
  const { toast } = useToast();
  const modalProps = MODAL_PROPS[upload.state];
  const removeUpload = async () => {
    try {
      await removeUploadMutation.mutateAsync(upload.id);
      navigate();
    } catch {
      toast("Failed to cancel the request. Please try again.");
    }
  };

  if (!modalProps) {
    return null;
  }

  return (
    <>
      <Button
        text={buttonText}
        type="primary"
        className="mr-space150 min-w-[164px] bg-white"
        onClick={() => setModalOpen(true)}
      />
      <Modal
        visible={modalOpen}
        escapable={true}
        handleCloseBtn={() => setModalOpen(false)}
      >
        <Prompt
          title={<h2 className="mt-space100">{modalProps.pTitle}</h2>}
          titleId="prompt-title"
          header={null}
          footer={
            <ModalFooter>
              <Button
                text={modalProps.pSecondaryButtonText}
                type="secondary"
                onClick={() => setModalOpen(false)}
              />
              <Button
                text={modalProps.pPrimaryButtonText}
                type="primary"
                loading={removeUploadMutation.isPending}
                onClick={removeUpload}
              />
            </ModalFooter>
          }
        >
          <p>{modalProps.pContent}</p>
        </Prompt>
      </Modal>
    </>
  );
};

export default DeleteUpload;
